<style scoped>
.ratio-box {
    @apply overflow-hidden;
}

.ratio-box ::v-deep div {
    /* top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); */
}
.icon.icon-paging-btn {
    display: block;
    @apply w-4 h-5 !important;

    & > svg {
        transform: scale(2);
    }
}
</style>

<template>
    <div
        class="flex flex-col items-center"
        v-if="slides.length > brokenImgIdxs.length"
    >
        <ratioBox :ratio="ratio" class="bg-transparent ratio-box">
            <intersectionContainer
                :mode="'continuous'"
                :targetIntersectionRatio="0.5"
                @visible="carouselVisibility = true"
                @invisible="carouselVisibility = false"
            >
                <carousel
                    ref="carousel"
                    :slides="slides"
                    :showControl="false"
                    :showIndicator="false"
                    :autoPlay="playing"
                    :brokenImgIdxs="brokenImgIdxs"
                    :lazyLoadImage="true"
                    :preloadAdjacentSlideNum="2"
                    @updateActiveSlide="v => (activeSlide = v)"
                    @clickSlide="clickAd"
                    @brokenImgIndex="brokenImgIndex"
                    class="cursor-pointer"
                />
            </intersectionContainer>

            <button
                v-if="showPauseBtn && slides.length - brokenImgIdxs.length > 1"
                class="absolute top-0 right-0 rounded-full bg-secondary text-white m-2 w-8 h-8 flex items-center justify-center opacity-75 focus:outline-none focus:bg-darkGrayishBlue"
                @click="playing = !playing"
            >
                <div class="icon">
                    <pause v-if="playing" />
                    <playArrow v-else />
                </div>
            </button>
        </ratioBox>
        <div
            class="hidden sm:flex justify-end w-full mt-2"
            v-if="slides.length - brokenImgIdxs.length > 1"
        >
            <button
                class="border border-secondary text-secondary text-sm focus:outline-none"
                @click="$refs.carousel.prev()"
            >
                <div class="icon icon-paging-btn">
                    <chevronLeft />
                </div>
            </button>
            <button
                class="border border-secondary text-secondary text-sm focus:outline-none ml-5"
                @click="$refs.carousel.next()"
            >
                <div class="icon icon-paging-btn">
                    <chevronRight />
                </div>
            </button>
        </div>
        <!-- <div class="flex flex-wrap mt-2" v-if="slides.length > 1">
            <button
                v-for="(s, si) in slides"
                :key="si"
                class="border p-1 px-2 bg-gray-300 text-gray-700 leading-tight text-sm mb-2"
                :class="{
                    'ml-2': si !== 0,
                    'bg-primary': si == activeSlide
                }"
                @click="$refs.carousel.setSlide(si)"
            >
                {{ si + 1 }}
            </button>
        </div> -->
    </div>
</template>

<script>
import carousel from '@/components/carousel.vue';
import ratioBox from '@/components/ratioBox.vue';
import ctx from '@/utils/ctx';
import chevronLeft from '../assets/svg/chevron_left.svg';
import chevronRight from '../assets/svg/chevron_right.svg';
import playArrow from '../assets/svg/play_arrow.svg';
import pause from '../assets/svg/pause.svg';
import { marketingEventHandler } from '../utils/marketingDataProcessor.js';
import intersectionContainer from '../components/intersectionContainer.vue';
import advrtEventHandler from '../utils/advertisementEventHandler';

const advertisementType = {
    product: 'product',
    mainAdvertisement: 'main'
};

export default {
    components: {
        carousel,
        ratioBox,
        chevronLeft,
        chevronRight,
        playArrow,
        pause,
        intersectionContainer
    },
    props: {
        advrtType: { type: String, required: true },
        showPauseBtn: { type: Boolean, default: true }
    },
    data() {
        return {
            activeSlide: 0,
            playing: false,
            brokenImgIdxs: [],
            carouselVisibility: false
        };
    },
    watch: {
        slides: {
            handler(v) {
                if (v.length > 1) {
                    this.playing = true;
                }
            },
            immediate: true
        },
        carouselVisibility: {
            handler() {
                this.checkActiveSlideIsVisible();
            },
            immediate: true
        },
        activeSlide: {
            handler() {
                this.checkActiveSlideIsVisible();
            },
            immediate: true
        }
    },
    computed: {
        list() {
            if (this.advrtType === advertisementType.product) {
                return this.$store.getters.productAdvertisement;
            } else if (this.advrtType === advertisementType.mainAdvertisement) {
                return this.$store.getters.mainAdvertisementList.map(l => ({
                    ...l,
                    prodKey: l.advrtProdKey
                }));
            }
            return [];
        },
        slides() {
            if (this.advrtType === advertisementType.product) {
                return this.list.map(l => ({
                    imgUrl: ctx('/advrtImage/' + l.advrtImgId),
                    shopListProdKey: l.shopListProdKey,
                    prodKey: l.prodKey,
                    shopListKey: l.shopListKey
                }));
            } else if (this.advrtType === advertisementType.mainAdvertisement) {
                return this.list.map(l => ({
                    imgUrl: ctx('/advrtImageFile/' + l.advrtImgId),
                    prodKey: l.prodKey,
                    shopListKey: l.shopListKey,
                    trckSlctKey: l.trckSlctKey
                }));
            }

            return [];
        },
        previewCmpyToken() {
            return this.$store.getters.previewCmpyToken;
        },
        ratio() {
            if (this.advrtType === advertisementType.product) {
                return 540 / 960;
            } else if (this.advrtType === advertisementType.mainAdvertisement) {
                return 1760 / 960;
            }
            return 1;
        }
    },
    methods: {
        clickAd(i) {
            const product = this.list[i];
            // Log click action
            if (
                (product.shopListKey && product.prodKey) ||
                product.trckSlctKey
            ) {
                marketingEventHandler.advertisementClick(
                    product.prodKey,
                    product.shopListKey,
                    this.advrtType.toUpperCase(),
                    product.trckSlctKey
                );
            }

            // Redirect to product (if any)
            if (this.advrtType === advertisementType.product) {
                const previewCmpyToken = this.previewCmpyToken;
                this.$router.push(
                    `/${
                        previewCmpyToken
                            ? `previewProduct/${previewCmpyToken}`
                            : 'product'
                    }/${product.shopListProdKey}`
                );
            } else if (this.advrtType === advertisementType.mainAdvertisement) {
                const advrt = this.list[i];
                advrtEventHandler.clickAdvertisement(advrt);
            }
        },
        brokenImgIndex(i) {
            if (this.brokenImgIdxs.every(ind => ind !== i)) {
                this.brokenImgIdxs.push(i);
            }
        },
        checkActiveSlideIsVisible() {
            // Do nothing, if slide is the same
            if (this.activeSlide === this._lastActiveSlide) {
                return;
            }

            const s = this.slides[this.activeSlide];
            if (
                this.carouselVisibility &&
                ((s.shopListKey && s.prodKey) || s.trckSlctKey)
            ) {
                marketingEventHandler.advertisementDisplay(
                    s.prodKey,
                    s.shopListKey,
                    this.advrtType.toUpperCase(),
                    s.trckSlctKey
                );
                this._lastActiveSlide = this.activeSlide;
            }
        }
    }
};
</script>
